module.exports = __webpack_public_path__ + "static/img/cover7.e8175590.jpg";